/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VettingRouteImport } from './routes/vetting'
import { Route as SignInRequiredRouteImport } from './routes/sign-in-required'
import { Route as Setup2faRouteImport } from './routes/setup-2fa'
import { Route as RatesRouteImport } from './routes/rates'
import { Route as PoliciesRouteImport } from './routes/policies'
import { Route as PayoutsRouteImport } from './routes/payouts'
import { Route as OperatorsRouteImport } from './routes/operators'
import { Route as NotificationsRouteImport } from './routes/notifications'
import { Route as MeRouteImport } from './routes/me'
import { Route as MapRouteImport } from './routes/map'
import { Route as ContactSubmissionsRouteImport } from './routes/contact-submissions'
import { Route as ComplianceRouteImport } from './routes/compliance'
import { Route as AuditRouteImport } from './routes/audit'
import { Route as AgreementsRouteImport } from './routes/agreements'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ShiftRequestsIndexRouteImport } from './routes/shift-requests.index'
import { Route as RatesIndexRouteImport } from './routes/rates/index'
import { Route as HomecareClientsIndexRouteImport } from './routes/homecare-clients/index'
import { Route as FacilitiesIndexRouteImport } from './routes/facilities/index'
import { Route as CaregiversIndexRouteImport } from './routes/caregivers/index'
import { Route as ShiftRequestsIdRouteImport } from './routes/shift-requests.$id'
import { Route as RatesModifiersRouteImport } from './routes/rates/modifiers'
import { Route as RatesFacilityOverridesRouteImport } from './routes/rates/facility-overrides'
import { Route as RatesCardsRouteImport } from './routes/rates/cards'
import { Route as HomecareClientsIdRouteImport } from './routes/homecare-clients/$id'
import { Route as FacilitiesIdRouteImport } from './routes/facilities/$id'
import { Route as CaregiversIdRouteImport } from './routes/caregivers/$id'
import { Route as BillingArAgingRouteImport } from './routes/billing/ar-aging'

const VettingRoute = VettingRouteImport.update({
  id: '/vetting',
  path: '/vetting',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRequiredRoute = SignInRequiredRouteImport.update({
  id: '/sign-in-required',
  path: '/sign-in-required',
  getParentRoute: () => rootRouteImport,
} as any)
const Setup2faRoute = Setup2faRouteImport.update({
  id: '/setup-2fa',
  path: '/setup-2fa',
  getParentRoute: () => rootRouteImport,
} as any)
const RatesRoute = RatesRouteImport.update({
  id: '/rates',
  path: '/rates',
  getParentRoute: () => rootRouteImport,
} as any)
const PoliciesRoute = PoliciesRouteImport.update({
  id: '/policies',
  path: '/policies',
  getParentRoute: () => rootRouteImport,
} as any)
const PayoutsRoute = PayoutsRouteImport.update({
  id: '/payouts',
  path: '/payouts',
  getParentRoute: () => rootRouteImport,
} as any)
const OperatorsRoute = OperatorsRouteImport.update({
  id: '/operators',
  path: '/operators',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsRoute = NotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const MeRoute = MeRouteImport.update({
  id: '/me',
  path: '/me',
  getParentRoute: () => rootRouteImport,
} as any)
const MapRoute = MapRouteImport.update({
  id: '/map',
  path: '/map',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactSubmissionsRoute = ContactSubmissionsRouteImport.update({
  id: '/contact-submissions',
  path: '/contact-submissions',
  getParentRoute: () => rootRouteImport,
} as any)
const ComplianceRoute = ComplianceRouteImport.update({
  id: '/compliance',
  path: '/compliance',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditRoute = AuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => rootRouteImport,
} as any)
const AgreementsRoute = AgreementsRouteImport.update({
  id: '/agreements',
  path: '/agreements',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ShiftRequestsIndexRoute = ShiftRequestsIndexRouteImport.update({
  id: '/shift-requests/',
  path: '/shift-requests/',
  getParentRoute: () => rootRouteImport,
} as any)
const RatesIndexRoute = RatesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RatesRoute,
} as any)
const HomecareClientsIndexRoute = HomecareClientsIndexRouteImport.update({
  id: '/homecare-clients/',
  path: '/homecare-clients/',
  getParentRoute: () => rootRouteImport,
} as any)
const FacilitiesIndexRoute = FacilitiesIndexRouteImport.update({
  id: '/facilities/',
  path: '/facilities/',
  getParentRoute: () => rootRouteImport,
} as any)
const CaregiversIndexRoute = CaregiversIndexRouteImport.update({
  id: '/caregivers/',
  path: '/caregivers/',
  getParentRoute: () => rootRouteImport,
} as any)
const ShiftRequestsIdRoute = ShiftRequestsIdRouteImport.update({
  id: '/shift-requests/$id',
  path: '/shift-requests/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const RatesModifiersRoute = RatesModifiersRouteImport.update({
  id: '/modifiers',
  path: '/modifiers',
  getParentRoute: () => RatesRoute,
} as any)
const RatesFacilityOverridesRoute = RatesFacilityOverridesRouteImport.update({
  id: '/facility-overrides',
  path: '/facility-overrides',
  getParentRoute: () => RatesRoute,
} as any)
const RatesCardsRoute = RatesCardsRouteImport.update({
  id: '/cards',
  path: '/cards',
  getParentRoute: () => RatesRoute,
} as any)
const HomecareClientsIdRoute = HomecareClientsIdRouteImport.update({
  id: '/homecare-clients/$id',
  path: '/homecare-clients/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const FacilitiesIdRoute = FacilitiesIdRouteImport.update({
  id: '/facilities/$id',
  path: '/facilities/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const CaregiversIdRoute = CaregiversIdRouteImport.update({
  id: '/caregivers/$id',
  path: '/caregivers/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingArAgingRoute = BillingArAgingRouteImport.update({
  id: '/billing/ar-aging',
  path: '/billing/ar-aging',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/agreements': typeof AgreementsRoute
  '/audit': typeof AuditRoute
  '/compliance': typeof ComplianceRoute
  '/contact-submissions': typeof ContactSubmissionsRoute
  '/map': typeof MapRoute
  '/me': typeof MeRoute
  '/notifications': typeof NotificationsRoute
  '/operators': typeof OperatorsRoute
  '/payouts': typeof PayoutsRoute
  '/policies': typeof PoliciesRoute
  '/rates': typeof RatesRouteWithChildren
  '/setup-2fa': typeof Setup2faRoute
  '/sign-in-required': typeof SignInRequiredRoute
  '/vetting': typeof VettingRoute
  '/billing/ar-aging': typeof BillingArAgingRoute
  '/caregivers/$id': typeof CaregiversIdRoute
  '/facilities/$id': typeof FacilitiesIdRoute
  '/homecare-clients/$id': typeof HomecareClientsIdRoute
  '/rates/cards': typeof RatesCardsRoute
  '/rates/facility-overrides': typeof RatesFacilityOverridesRoute
  '/rates/modifiers': typeof RatesModifiersRoute
  '/shift-requests/$id': typeof ShiftRequestsIdRoute
  '/caregivers/': typeof CaregiversIndexRoute
  '/facilities/': typeof FacilitiesIndexRoute
  '/homecare-clients/': typeof HomecareClientsIndexRoute
  '/rates/': typeof RatesIndexRoute
  '/shift-requests/': typeof ShiftRequestsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/agreements': typeof AgreementsRoute
  '/audit': typeof AuditRoute
  '/compliance': typeof ComplianceRoute
  '/contact-submissions': typeof ContactSubmissionsRoute
  '/map': typeof MapRoute
  '/me': typeof MeRoute
  '/notifications': typeof NotificationsRoute
  '/operators': typeof OperatorsRoute
  '/payouts': typeof PayoutsRoute
  '/policies': typeof PoliciesRoute
  '/setup-2fa': typeof Setup2faRoute
  '/sign-in-required': typeof SignInRequiredRoute
  '/vetting': typeof VettingRoute
  '/billing/ar-aging': typeof BillingArAgingRoute
  '/caregivers/$id': typeof CaregiversIdRoute
  '/facilities/$id': typeof FacilitiesIdRoute
  '/homecare-clients/$id': typeof HomecareClientsIdRoute
  '/rates/cards': typeof RatesCardsRoute
  '/rates/facility-overrides': typeof RatesFacilityOverridesRoute
  '/rates/modifiers': typeof RatesModifiersRoute
  '/shift-requests/$id': typeof ShiftRequestsIdRoute
  '/caregivers': typeof CaregiversIndexRoute
  '/facilities': typeof FacilitiesIndexRoute
  '/homecare-clients': typeof HomecareClientsIndexRoute
  '/rates': typeof RatesIndexRoute
  '/shift-requests': typeof ShiftRequestsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/agreements': typeof AgreementsRoute
  '/audit': typeof AuditRoute
  '/compliance': typeof ComplianceRoute
  '/contact-submissions': typeof ContactSubmissionsRoute
  '/map': typeof MapRoute
  '/me': typeof MeRoute
  '/notifications': typeof NotificationsRoute
  '/operators': typeof OperatorsRoute
  '/payouts': typeof PayoutsRoute
  '/policies': typeof PoliciesRoute
  '/rates': typeof RatesRouteWithChildren
  '/setup-2fa': typeof Setup2faRoute
  '/sign-in-required': typeof SignInRequiredRoute
  '/vetting': typeof VettingRoute
  '/billing/ar-aging': typeof BillingArAgingRoute
  '/caregivers/$id': typeof CaregiversIdRoute
  '/facilities/$id': typeof FacilitiesIdRoute
  '/homecare-clients/$id': typeof HomecareClientsIdRoute
  '/rates/cards': typeof RatesCardsRoute
  '/rates/facility-overrides': typeof RatesFacilityOverridesRoute
  '/rates/modifiers': typeof RatesModifiersRoute
  '/shift-requests/$id': typeof ShiftRequestsIdRoute
  '/caregivers/': typeof CaregiversIndexRoute
  '/facilities/': typeof FacilitiesIndexRoute
  '/homecare-clients/': typeof HomecareClientsIndexRoute
  '/rates/': typeof RatesIndexRoute
  '/shift-requests/': typeof ShiftRequestsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/agreements'
    | '/audit'
    | '/compliance'
    | '/contact-submissions'
    | '/map'
    | '/me'
    | '/notifications'
    | '/operators'
    | '/payouts'
    | '/policies'
    | '/rates'
    | '/setup-2fa'
    | '/sign-in-required'
    | '/vetting'
    | '/billing/ar-aging'
    | '/caregivers/$id'
    | '/facilities/$id'
    | '/homecare-clients/$id'
    | '/rates/cards'
    | '/rates/facility-overrides'
    | '/rates/modifiers'
    | '/shift-requests/$id'
    | '/caregivers/'
    | '/facilities/'
    | '/homecare-clients/'
    | '/rates/'
    | '/shift-requests/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/agreements'
    | '/audit'
    | '/compliance'
    | '/contact-submissions'
    | '/map'
    | '/me'
    | '/notifications'
    | '/operators'
    | '/payouts'
    | '/policies'
    | '/setup-2fa'
    | '/sign-in-required'
    | '/vetting'
    | '/billing/ar-aging'
    | '/caregivers/$id'
    | '/facilities/$id'
    | '/homecare-clients/$id'
    | '/rates/cards'
    | '/rates/facility-overrides'
    | '/rates/modifiers'
    | '/shift-requests/$id'
    | '/caregivers'
    | '/facilities'
    | '/homecare-clients'
    | '/rates'
    | '/shift-requests'
  id:
    | '__root__'
    | '/'
    | '/agreements'
    | '/audit'
    | '/compliance'
    | '/contact-submissions'
    | '/map'
    | '/me'
    | '/notifications'
    | '/operators'
    | '/payouts'
    | '/policies'
    | '/rates'
    | '/setup-2fa'
    | '/sign-in-required'
    | '/vetting'
    | '/billing/ar-aging'
    | '/caregivers/$id'
    | '/facilities/$id'
    | '/homecare-clients/$id'
    | '/rates/cards'
    | '/rates/facility-overrides'
    | '/rates/modifiers'
    | '/shift-requests/$id'
    | '/caregivers/'
    | '/facilities/'
    | '/homecare-clients/'
    | '/rates/'
    | '/shift-requests/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AgreementsRoute: typeof AgreementsRoute
  AuditRoute: typeof AuditRoute
  ComplianceRoute: typeof ComplianceRoute
  ContactSubmissionsRoute: typeof ContactSubmissionsRoute
  MapRoute: typeof MapRoute
  MeRoute: typeof MeRoute
  NotificationsRoute: typeof NotificationsRoute
  OperatorsRoute: typeof OperatorsRoute
  PayoutsRoute: typeof PayoutsRoute
  PoliciesRoute: typeof PoliciesRoute
  RatesRoute: typeof RatesRouteWithChildren
  Setup2faRoute: typeof Setup2faRoute
  SignInRequiredRoute: typeof SignInRequiredRoute
  VettingRoute: typeof VettingRoute
  BillingArAgingRoute: typeof BillingArAgingRoute
  CaregiversIdRoute: typeof CaregiversIdRoute
  FacilitiesIdRoute: typeof FacilitiesIdRoute
  HomecareClientsIdRoute: typeof HomecareClientsIdRoute
  ShiftRequestsIdRoute: typeof ShiftRequestsIdRoute
  CaregiversIndexRoute: typeof CaregiversIndexRoute
  FacilitiesIndexRoute: typeof FacilitiesIndexRoute
  HomecareClientsIndexRoute: typeof HomecareClientsIndexRoute
  ShiftRequestsIndexRoute: typeof ShiftRequestsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/vetting': {
      id: '/vetting'
      path: '/vetting'
      fullPath: '/vetting'
      preLoaderRoute: typeof VettingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in-required': {
      id: '/sign-in-required'
      path: '/sign-in-required'
      fullPath: '/sign-in-required'
      preLoaderRoute: typeof SignInRequiredRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/setup-2fa': {
      id: '/setup-2fa'
      path: '/setup-2fa'
      fullPath: '/setup-2fa'
      preLoaderRoute: typeof Setup2faRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rates': {
      id: '/rates'
      path: '/rates'
      fullPath: '/rates'
      preLoaderRoute: typeof RatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/policies': {
      id: '/policies'
      path: '/policies'
      fullPath: '/policies'
      preLoaderRoute: typeof PoliciesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payouts': {
      id: '/payouts'
      path: '/payouts'
      fullPath: '/payouts'
      preLoaderRoute: typeof PayoutsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/operators': {
      id: '/operators'
      path: '/operators'
      fullPath: '/operators'
      preLoaderRoute: typeof OperatorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications': {
      id: '/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof NotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/me': {
      id: '/me'
      path: '/me'
      fullPath: '/me'
      preLoaderRoute: typeof MeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/map': {
      id: '/map'
      path: '/map'
      fullPath: '/map'
      preLoaderRoute: typeof MapRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact-submissions': {
      id: '/contact-submissions'
      path: '/contact-submissions'
      fullPath: '/contact-submissions'
      preLoaderRoute: typeof ContactSubmissionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/compliance': {
      id: '/compliance'
      path: '/compliance'
      fullPath: '/compliance'
      preLoaderRoute: typeof ComplianceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audit': {
      id: '/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agreements': {
      id: '/agreements'
      path: '/agreements'
      fullPath: '/agreements'
      preLoaderRoute: typeof AgreementsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shift-requests/': {
      id: '/shift-requests/'
      path: '/shift-requests'
      fullPath: '/shift-requests/'
      preLoaderRoute: typeof ShiftRequestsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rates/': {
      id: '/rates/'
      path: '/'
      fullPath: '/rates/'
      preLoaderRoute: typeof RatesIndexRouteImport
      parentRoute: typeof RatesRoute
    }
    '/homecare-clients/': {
      id: '/homecare-clients/'
      path: '/homecare-clients'
      fullPath: '/homecare-clients/'
      preLoaderRoute: typeof HomecareClientsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/facilities/': {
      id: '/facilities/'
      path: '/facilities'
      fullPath: '/facilities/'
      preLoaderRoute: typeof FacilitiesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/caregivers/': {
      id: '/caregivers/'
      path: '/caregivers'
      fullPath: '/caregivers/'
      preLoaderRoute: typeof CaregiversIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shift-requests/$id': {
      id: '/shift-requests/$id'
      path: '/shift-requests/$id'
      fullPath: '/shift-requests/$id'
      preLoaderRoute: typeof ShiftRequestsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rates/modifiers': {
      id: '/rates/modifiers'
      path: '/modifiers'
      fullPath: '/rates/modifiers'
      preLoaderRoute: typeof RatesModifiersRouteImport
      parentRoute: typeof RatesRoute
    }
    '/rates/facility-overrides': {
      id: '/rates/facility-overrides'
      path: '/facility-overrides'
      fullPath: '/rates/facility-overrides'
      preLoaderRoute: typeof RatesFacilityOverridesRouteImport
      parentRoute: typeof RatesRoute
    }
    '/rates/cards': {
      id: '/rates/cards'
      path: '/cards'
      fullPath: '/rates/cards'
      preLoaderRoute: typeof RatesCardsRouteImport
      parentRoute: typeof RatesRoute
    }
    '/homecare-clients/$id': {
      id: '/homecare-clients/$id'
      path: '/homecare-clients/$id'
      fullPath: '/homecare-clients/$id'
      preLoaderRoute: typeof HomecareClientsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/facilities/$id': {
      id: '/facilities/$id'
      path: '/facilities/$id'
      fullPath: '/facilities/$id'
      preLoaderRoute: typeof FacilitiesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/caregivers/$id': {
      id: '/caregivers/$id'
      path: '/caregivers/$id'
      fullPath: '/caregivers/$id'
      preLoaderRoute: typeof CaregiversIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing/ar-aging': {
      id: '/billing/ar-aging'
      path: '/billing/ar-aging'
      fullPath: '/billing/ar-aging'
      preLoaderRoute: typeof BillingArAgingRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface RatesRouteChildren {
  RatesCardsRoute: typeof RatesCardsRoute
  RatesFacilityOverridesRoute: typeof RatesFacilityOverridesRoute
  RatesModifiersRoute: typeof RatesModifiersRoute
  RatesIndexRoute: typeof RatesIndexRoute
}

const RatesRouteChildren: RatesRouteChildren = {
  RatesCardsRoute: RatesCardsRoute,
  RatesFacilityOverridesRoute: RatesFacilityOverridesRoute,
  RatesModifiersRoute: RatesModifiersRoute,
  RatesIndexRoute: RatesIndexRoute,
}

const RatesRouteWithChildren = RatesRoute._addFileChildren(RatesRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AgreementsRoute: AgreementsRoute,
  AuditRoute: AuditRoute,
  ComplianceRoute: ComplianceRoute,
  ContactSubmissionsRoute: ContactSubmissionsRoute,
  MapRoute: MapRoute,
  MeRoute: MeRoute,
  NotificationsRoute: NotificationsRoute,
  OperatorsRoute: OperatorsRoute,
  PayoutsRoute: PayoutsRoute,
  PoliciesRoute: PoliciesRoute,
  RatesRoute: RatesRouteWithChildren,
  Setup2faRoute: Setup2faRoute,
  SignInRequiredRoute: SignInRequiredRoute,
  VettingRoute: VettingRoute,
  BillingArAgingRoute: BillingArAgingRoute,
  CaregiversIdRoute: CaregiversIdRoute,
  FacilitiesIdRoute: FacilitiesIdRoute,
  HomecareClientsIdRoute: HomecareClientsIdRoute,
  ShiftRequestsIdRoute: ShiftRequestsIdRoute,
  CaregiversIndexRoute: CaregiversIndexRoute,
  FacilitiesIndexRoute: FacilitiesIndexRoute,
  HomecareClientsIndexRoute: HomecareClientsIndexRoute,
  ShiftRequestsIndexRoute: ShiftRequestsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
